export enum ContactTypeId {
  owner = 1,
  manager = 4,
  billing = 5,
}

export interface ContactModel {
  fullName: string
  email: string
  phone: string
  position: ContactTypeId
}
